
import Env from './env';
import axios from 'axios'
import Qs from "qs";
axios.defaults.withCredentials = false;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头

// 添加一个响应拦截器
axios.interceptors.request.use(config => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    config.data = Qs.stringify(config.data); //数据转化,也可以使用qs转换
    config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded' //配置请求头
    }
    //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
    const token = localStorage.getItem("token");;//这里取token之前，你肯定需要先拿到token,存一下
    if (token) {
        //config.params = { 'token': token } //如果要求携带在参数中
        config.headers.Authorization = token; //如果要求携带在请求头中
    }
    return config
}, error => {
    Promise.reject(error)
})
//基地址
let base = Env.baseURL;

export const ISDEV = Env.isDev;

//通用方法
export const POST = (url, params, type = {}) => {
    return axios.post(`${base}${url}`, params, type).then(res => res.data)
}

export const GET = (url, params) => {
    return axios.get(`${base}${url}`, { params: params }).then(res => res.data)
}

export const PUT = (url, params) => {
    return axios.put(`${base}${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
    return axios.delete(`${base}${url}`, { params: params }).then(res => res.data)
}

export const PATCH = (url, params) => {
    return axios.patch(`${base}${url}`, params).then(res => res.data)
}
